import { render, staticRenderFns } from "./partnership-widget.vue?vue&type=template&id=c55da64c&"
import script from "./partnership-widget.vue?vue&type=script&lang=js&"
export * from "./partnership-widget.vue?vue&type=script&lang=js&"
import style0 from "./partnership-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports